import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { ClienteAnaliseMercadoHeaderModule } from '../header';
import { ClienteAnaliseMercadoClassificacaoLancamentoModule } from '../classificacao/lancamento';
import { ClienteAnaliseMercadoLancamentoModule } from '../lancamento';
import { ClienteCentralCompraModule } from '../../pessoa/cliente/central-compra';

import { ClienteAnaliseMercadoFormComponent } from './cliente-analise-mercado-form.component';

@NgModule({
    imports: [
        SharedModule,
        ClienteAnaliseMercadoHeaderModule,
        ClienteAnaliseMercadoClassificacaoLancamentoModule,
        ClienteAnaliseMercadoLancamentoModule,
        ClienteCentralCompraModule
    ],
    declarations: [
        ClienteAnaliseMercadoFormComponent
    ],
    exports: [
        ClienteAnaliseMercadoFormComponent
    ]
})
export class ClienteAnaliseMercadoFormModule { }
